import React from 'react';
import { useShop } from '../../contexts/ShopContext';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell';

interface HeaderProps {
  user: { username: string; role: string };
  onLogout: () => void;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout, children }) => {
  const navigate = useNavigate();
  const { name, logoUrl } = useShop();
  return (
    <header className="dashboard-header">
      <div className="header-content">
        <span className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          {logoUrl
            ? <img src={logoUrl} alt={name} className="logo-img" />
            : <img src="/logo-mark.png" alt={name || 'T-POS'} className="logo-img" />}
          <span className="logo-text">{name || 'T-POS'}</span>
        </span>
        <div className="user-info">
          <span>Xin chào, {user.username}</span>
          <NotificationBell />
          {children}
          <button className="logout-button" onClick={onLogout}>Đăng xuất</button>
        </div>
      </div>
    </header>
  );
};

export default Header; 